import React from "react";
import { useThemeMode } from "../../context/contextTheme";
import { useWeb } from "../../context/Dashboard/contextWeb";
import { ResponsiveContainer, PieChart, Pie, Legend, Tooltip } from "recharts";

const PieChartGraph = () => {
  const { theme } = useThemeMode();
  const { urlVulTable } = useWeb();
  const hasVulTable = Array.isArray(urlVulTable) && urlVulTable.length > 0;
  let critical = 0, high = 0, medium = 0, low = 0;

  if (hasVulTable) {
    urlVulTable.forEach(v => {
      if (!v.risk) return;
      const risk = v.risk.toLowerCase();
      if (risk === "critical") critical++;
      else if (risk === "high") high++;
      else if (risk === "medium") medium++;
      else if (risk === "low") low++;
    });
  }

  const pieData = [
    { name: "Critical", value: critical, fill: "#6d2d9d" },
    { name: "High",     value: high,     fill: "#fc0000" },
    { name: "Medium",   value: medium,   fill: "#ffc000" },
    { name: "Low",      value: low,      fill: "#92d14f" },
  ];

  const filteredPieData = pieData.filter(d => d.value > 0);
  const hasSlices = filteredPieData.length > 0;

  const renderLabel = ({ name, value }) => `${name}: ${value}`;

  if (!hasVulTable) {
    return (
      <Card theme={theme} title="Web Vulnerability Distribution">
        <EmptyMsg
          theme={theme}
          icon="bi-shield-fill-check"
          text="No vulnerability data available. Run a web scan!"
        />
      </Card>
    );
  }

  if (!hasSlices) {
    return (
      <Card theme={theme} title="Web Vulnerability Distribution">
        <EmptyMsg
          theme={theme}
          icon="bi-shield-fill-check"
          text="No vulnerabilities detected."
        />
      </Card>
    );
  }

  return (
    <Card theme={theme} title="Web Vulnerability Distribution">
      <div className="p-2">
        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie
              data={filteredPieData}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              innerRadius={80}
              outerRadius={100}
              label={renderLabel}
              isAnimationActive={false}
            />
            <Legend
              iconSize={10}
              layout="vertical"
              verticalAlign="middle"
              align="right"
              wrapperStyle={{ color: theme.textColor }}
            />
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
};

/* CARD WRAPPER */
const Card = ({ theme, title, children }) => (
  <div className="p-2">
    <div
      className="card rounded-4 shadow-sm"
      style={{
        width: "calc(620px + 1rem)",
        height: 400,
        backgroundColor: theme.background,
        border: `1px solid ${theme.border}`,
      }}
    >
      <div className="card-body">
        <h6
          className="card-title fw-semibold text-center mt-4"
          style={{ fontSize: 20, color: theme.textColor }}
        >
          {title}
        </h6>
        {children}
      </div>
    </div>
  </div>
);

/* EMPTY UI */
const EmptyMsg = ({ theme, icon, text }) => (
  <div className="h-75 d-flex flex-column justify-content-center align-items-center">
    <i className={`bi ${icon} fs-1`} style={{ color: theme.textMuted }}></i>
    <p className="fw-semibold mt-2" style={{ color: theme.textMuted }}>
      {text}
    </p>
  </div>
);

export default PieChartGraph;
